import React from 'react';
import Author from './Author';

export default function AuthorsList({
  authors = [],
  track,
  withColumns,
}) {
  if (!authors.length) return null;

  return (
    <div className={`authors-list follower-list ${withColumns ? 'with-columns' : ''} with-buttons`}>
      <ul>{ authors.map(author => (
        <li key={author.scopusAuthorId}>
          <Author {...author} track={track} />
        </li>
      ))}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/AuthorsList/AuthorsList.js